const statsTypes = {
  RESET_DAILY_LEAD_INSIGHT_STATE: 'RESET_DAILY_LEAD_INSIGHT_STATE',
  DAILY_LEAD_INSIGHTS: {
    REQUEST: 'DAILY_LEAD_INSIGHTS.REQUEST',
    SUCCESS: 'DAILY_LEAD_INSIGHTS.SUCCESS',
    FAILURE: 'DAILY_LEAD_INSIGHTS.FAILURE',
  },
};

export default statsTypes;
